import { useQuery } from "@tanstack/react-query"
import API from "@/lib/api"
import useUser from "@/lib/useUser"
import { WishlistItem } from "@/types"

const useWishlist = () => {
  const { user } = useUser()

  return useQuery<WishlistItem[], Error>({
    queryKey: ["wishlist"],
    queryFn: () => API.services.wishlist.get(user?.access_token!),
    enabled: !!user && !!user.access_token,
  })
}

export default useWishlist
